import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';
import {LogLevel, LogType} from 'sfccAPI/interfaces';

export const endpointsMap: IEndpointsMap = {
	LOG: {
		path: 'log',
		method: 'POST'
	}
};

export enum LogSource {
	PAGE = 'page error',
	COMPONENT = 'component error',
	PRODUCT = 'product error',
	SESSION = 'session sync error',
	SCAPI = 'scapi context error'
}

export interface ILogOptions extends IBaseFetchOptions {
	body: {
		level: LogLevel,
		type: LogType,
		title: string,
		source: LogSource,
		stackTrace: object
	}
}

export interface ILogResponse extends IBaseResponse {
	error: boolean;
}
